import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { action } from "@ember/object";
import DButton from "discourse/components/d-button";
import TopicParticipants from "discourse/components/topic-map/topic-participants";
import replaceEmoji from "discourse/helpers/replace-emoji";
import i18n from "discourse-common/helpers/i18n";
import and from "truth-helpers/helpers/and";
import lt from "truth-helpers/helpers/lt";
import not from "truth-helpers/helpers/not";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
const TRUNCATED_LINKS_LIMIT = 5;
export default class TopicMapExpanded extends Component {
  static #_ = (() => dt7948.g(this.prototype, "allLinksShown", [tracked], function () {
    return false;
  }))();
  #allLinksShown = (() => (dt7948.i(this, "allLinksShown"), void 0))();
  get topicLinks() {
    return this.args.topicDetails.links;
  }
  get participants() {
    return this.args.topicDetails.participants;
  }
  showAllLinks() {
    this.allLinksShown = true;
  }
  static #_2 = (() => dt7948.n(this.prototype, "showAllLinks", [action]))();
  get linksToShow() {
    return this.allLinksShown ? this.topicLinks : this.topicLinks.slice(0, TRUNCATED_LINKS_LIMIT);
  }
  static #_3 = (() => setComponentTemplate(createTemplateFactory(
  /*
    
      {{#if this.participants}}
        <section class="avatars">
          <TopicParticipants
            @title={{i18n "topic_map.participants_title"}}
            @userFilters={{@userFilters}}
            @participants={{this.participants}}
          />
        </section>
      {{/if}}
      {{#if this.topicLinks}}
        <section class="links">
          <h3>{{i18n "topic_map.links_title"}}</h3>
          <table class="topic-links">
            <tbody>
              {{#each this.linksToShow as |link|}}
                <tr>
                  <td>
                    <span
                      class="badge badge-notification clicks"
                      title={{i18n "topic_map.clicks" count=link.clicks}}
                    >
                      {{link.clicks}}
                    </span>
                  </td>
                  <td>
                    <TopicMapLink
                      @attachment={{link.attachment}}
                      @title={{link.title}}
                      @rootDomain={{link.root_domain}}
                      @url={{link.url}}
                      @userId={{link.user_id}}
                    />
                  </td>
                </tr>
              {{/each}}
            </tbody>
          </table>
          {{#if
            (and
              (not this.allLinksShown)
              (lt TRUNCATED_LINKS_LIMIT this.topicLinks.length)
            )
          }}
            <div class="link-summary">
              <span>
                <DButton
                  @action={{this.showAllLinks}}
                  @title="topic_map.links_shown"
                  @icon="chevron-down"
                  class="btn-flat"
                />
              </span>
            </div>
          {{/if}}
        </section>
      {{/if}}
    
  */
  {
    "id": "/73A/2Nj",
    "block": "[[[1,\"\\n\"],[41,[30,0,[\"participants\"]],[[[1,\"      \"],[10,\"section\"],[14,0,\"avatars\"],[12],[1,\"\\n        \"],[8,[32,0],null,[[\"@title\",\"@userFilters\",\"@participants\"],[[28,[32,1],[\"topic_map.participants_title\"],null],[30,1],[30,0,[\"participants\"]]]],null],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"topicLinks\"]],[[[1,\"      \"],[10,\"section\"],[14,0,\"links\"],[12],[1,\"\\n        \"],[10,\"h3\"],[12],[1,[28,[32,1],[\"topic_map.links_title\"],null]],[13],[1,\"\\n        \"],[10,\"table\"],[14,0,\"topic-links\"],[12],[1,\"\\n          \"],[10,\"tbody\"],[12],[1,\"\\n\"],[42,[28,[31,2],[[28,[31,2],[[30,0,[\"linksToShow\"]]],null]],null],null,[[[1,\"              \"],[10,\"tr\"],[12],[1,\"\\n                \"],[10,\"td\"],[12],[1,\"\\n                  \"],[10,1],[14,0,\"badge badge-notification clicks\"],[15,\"title\",[28,[32,1],[\"topic_map.clicks\"],[[\"count\"],[[30,2,[\"clicks\"]]]]]],[12],[1,\"\\n                    \"],[1,[30,2,[\"clicks\"]]],[1,\"\\n                  \"],[13],[1,\"\\n                \"],[13],[1,\"\\n                \"],[10,\"td\"],[12],[1,\"\\n                  \"],[8,[32,2],null,[[\"@attachment\",\"@title\",\"@rootDomain\",\"@url\",\"@userId\"],[[30,2,[\"attachment\"]],[30,2,[\"title\"]],[30,2,[\"root_domain\"]],[30,2,[\"url\"]],[30,2,[\"user_id\"]]]],null],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n\"]],[2]],null],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"],[41,[28,[32,3],[[28,[32,4],[[30,0,[\"allLinksShown\"]]],null],[28,[32,5],[[32,6],[30,0,[\"topicLinks\",\"length\"]]],null]],null],[[[1,\"          \"],[10,0],[14,0,\"link-summary\"],[12],[1,\"\\n            \"],[10,1],[12],[1,\"\\n              \"],[8,[32,7],[[24,0,\"btn-flat\"]],[[\"@action\",\"@title\",\"@icon\"],[[30,0,[\"showAllLinks\"]],\"topic_map.links_shown\",\"chevron-down\"]],null],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"]],[\"@userFilters\",\"link\"],false,[\"if\",\"each\",\"-track-array\"]]",
    "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/topic-map/topic-map-expanded.js",
    "scope": () => [TopicParticipants, i18n, TopicMapLink, and, not, lt, TRUNCATED_LINKS_LIMIT, DButton],
    "isStrictMode": true
  }), this))();
}
let TopicMapLink = class TopicMapLink extends Component {
  get linkClasses() {
    return this.args.attachment ? "topic-link track-link attachment" : "topic-link track-link";
  }
  get truncatedContent() {
    const truncateLength1 = 85;
    const content1 = this.args.title || this.args.url;
    return content1.length > truncateLength1 ? `${content1.slice(0, truncateLength1).trim()}...` : content1;
  }
  static #_ = (() => setComponentTemplate(createTemplateFactory(
  /*
    
      <a
        class={{this.linkClasses}}
        href={{@url}}
        title={{@url}}
        data-user-id={{@userId}}
        data-ignore-post-id="true"
        target="_blank"
        rel="nofollow ugc noopener noreferrer"
      >
        {{#if @title}}
          {{replaceEmoji this.truncatedContent}}
        {{else}}
          {{this.truncatedContent}}
        {{/if}}
      </a>
      {{#if (and @title @rootDomain)}}
        <span class="domain">
          {{@rootDomain}}
        </span>
      {{/if}}
    
  */
  {
    "id": "25OzvvFW",
    "block": "[[[1,\"\\n    \"],[10,3],[15,0,[30,0,[\"linkClasses\"]]],[15,6,[30,1]],[15,\"title\",[30,1]],[15,\"data-user-id\",[30,2]],[14,\"data-ignore-post-id\",\"true\"],[14,\"target\",\"_blank\"],[14,\"rel\",\"nofollow ugc noopener noreferrer\"],[12],[1,\"\\n\"],[41,[30,3],[[[1,\"        \"],[1,[28,[32,0],[[30,0,[\"truncatedContent\"]]],null]],[1,\"\\n\"]],[]],[[[1,\"        \"],[1,[30,0,[\"truncatedContent\"]]],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n\"],[41,[28,[32,1],[[30,3],[30,4]],null],[[[1,\"      \"],[10,1],[14,0,\"domain\"],[12],[1,\"\\n        \"],[1,[30,4]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"]],[\"@url\",\"@userId\",\"@title\",\"@rootDomain\"],false,[\"if\"]]",
    "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/topic-map/topic-map-expanded.js",
    "scope": () => [replaceEmoji, and],
    "isStrictMode": true
  }), this))();
};